/* eslint-disable lines-between-class-members */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { ds } from 'mewe/stores/ds';
import { A } from '@ember/array';
import * as LottiePlayer from '@lottiefiles/lottie-player';

export default class MwToaster extends Component {
  @tracked messages;

  constructor() {
    super(...arguments);
    this.messages = ds.toasterMessages.items;
  }

  @action
  messageInserted(element, message) {
    if (message.length) {
      message = message[0];
    }

    message.element = element;

    const hasAction = message.action && typeof message.action === 'function';
    const actionEl = element.querySelector('#error-action');

    if (hasAction && actionEl) {
      actionEl.addEventListener('click', message.action);
    }
  }

  @action
  closeToast(message) {
    message.destroyToast();
  }
}
